class SizeGuideButton extends HTMLElement {
  connectedCallback() {
    this.popup = document.getElementById('SizeGuidePopup');

    if (!this.popup) return;

    this.overlay = this.popup.querySelector('.size-guide-popup__overlay');
    this.closeButton = this.popup.querySelector('.size-guide-popup__close');

    this.addEventListener('click', this.openPopup);

    this.overlay?.addEventListener('click', this.closePopup);
    this.closeButton?.addEventListener('click', this.closePopup);

    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.openPopup);

    this.overlay?.removeEventListener('click', this.closePopup);
    this.closeButton?.removeEventListener('click', this.closePopup);

    document.removeEventListener('keydown', this.handleKeydown);
  }

  openPopup = (event) => {
    event.preventDefault();

    this.popup.hidden = false;

    requestAnimationFrame(() => {
      this.popup.classList.add('is-open');
    });

    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
  };

  closePopup = () => {
    this.popup.classList.remove('is-open');

    setTimeout(() => {
      this.popup.hidden = true;
    }, 250);

    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape' && !this.popup.hidden) {
      this.closePopup();
    }
  };
}

if (!customElements.get('size-guide-button')) {
  customElements.define('size-guide-button', SizeGuideButton);
}